import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { initSectionThemeTriggers } from "../../utils/sectionThemeTriggers";
import { initFooterClamp } from "../../utils/footerClamp";

const ENTRANCE_GAP = 24;
const ENTRANCE_DELAY = 1; // sync with the hero's own intro reveal (see Anim.js GROUP_DELAY)

export default class ModalCollectionPush {
  constructor(el) {
    this.el = el;

    // Keep the card 12px clear of the footer (sticky --product variant rides
    // up with its zone near the end; the base variant is fixed) — applies
    // regardless of account type. Only translates `y`, so it composes safely
    // with the `x`-only entrance slide below (same split used by NotifStack).
    initFooterClamp(el);

    this.initEntrance();
    this.initHideOnProduct();

    // Lifetime accounts get a fixed theme (see --lifetime modifier), not a
    // scroll-driven one.
    if (el.classList.contains("c-modal-collection-push--lifetime")) return;

    initSectionThemeTriggers(el);
  }

  // Slides the card in from off-screen right on page load.
  initEntrance() {
    gsap.from(this.el, {
      x: this.el.offsetWidth + ENTRANCE_GAP,
      duration: 1,
      ease: "expo.out",
      delay: ENTRANCE_DELAY,
    });
  }

  // The collection page's product section already carries its own price +
  // "Add to cart" CTA, so the floating card is hidden once the section's top
  // reaches 75% of the viewport height until its bottom leaves the top. No-op
  // on pages without it (e.g. the product page).
  initHideOnProduct() {
    const section = document.querySelector(".page-collection__product");
    if (!section) return;

    ScrollTrigger.create({
      trigger: section,
      start: "top 75%",
      end: "bottom top",
      onToggle: ({ isActive }) =>
        this.el.classList.toggle("is-hidden", isActive),
    });
  }
}
